import { render, staticRenderFns } from "./driveXq.vue?vue&type=template&id=95d4f2d4&scoped=true"
import script from "./driveXq.vue?vue&type=script&lang=js"
export * from "./driveXq.vue?vue&type=script&lang=js"
import style0 from "./driveXq.vue?vue&type=style&index=0&id=95d4f2d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d4f2d4",
  null
  
)

export default component.exports